import React, { PureComponent } from "react";
import { DatePicker, Form } from "antd";
import moment from "moment";
import "moment/locale/fr";
import _ from "lodash";

class DateForm extends PureComponent {
  isDisabled = current => {
    const { availableDates } = this.props;

    const todayHour = Number(moment().format("HH"));
    //Days before can not be selected
    if (current < moment().startOf("day")) return true;
    if (todayHour > 19 && moment(current).format("YYYY-MM-DD") === moment().format("YYYY-MM-DD")) return true;
    for (let i = 0; i < availableDates.length; i++) {
      const date = availableDates[i];
      const startDate = moment(date.startDate);
      const endDate = moment(date.endDate);

      if (current.isAfter(startDate) && current.isBefore(endDate)) return false;
    }
    return true;
  };

  render() {
    const FormItem = Form.Item;
    const todayHour = Number(moment().format("HH"));

    return (
      <FormItem {...this.props.formItemLayout} label="Date de l'évènement">
        {this.props.getFieldDecorator("date", {
          initialValue: !_.isEmpty(this.props.eventInfos)
            ? moment(moment(this.props.eventInfos.start_date).format("DD/MM/YYYY"), "DD/MM/YYYY")
            : todayHour > 19
            ? moment(
                moment()
                  .add(1, "day")
                  .format("DD/MM/YYYY"),
                "DD/MM/YYYY"
              )
            : moment(moment().format("DD/MM/YYYY"), "DD/MM/YYYY"),
          rules: [
            {
              required: true,
              message: "La journée de la visite doit être choisie"
            }
          ]
        })(
          <DatePicker
            disabledDate={this.isDisabled}
            format={"DD/MM/YYYY"}
            onOpenChange={status => {
              if (status) this.props.getAvailableDateRange();
            }}
            disabled={this.props.disabled}
          />
        )}
      </FormItem>
    );
  }
}

export default DateForm;



// WEBPACK FOOTER //
// src/components/planning/FormItems/DatePicker.js